import { useEffect, useMemo, useRef, useState } from 'react';

export function getImageAspectRatio(imageSrc) {
  return new Promise((resolve) => {
    const image = new Image();
    image.src = imageSrc;

    image.addEventListener('load', () => {
      resolve({
        imageSrc,
        aspectRatio:
          image.width && image.height ? image.width / image.height : 0
      });
    });

    image.addEventListener('error', () => {
      resolve({
        imageSrc,
        aspectRatio: 1
      });
    });
  });
}

export function useImagesAspectRatios(images = []) {
  const [imagesAspectRatios] = useState(new Map());
  const [resultRatios, setResultRatios] = useState([]);
  const prevImagesRef = useRef([]);

  const imagesSources = useMemo(
    () => images.map(({ image }) => image.url),
    [images]
  );

  useEffect(() => {
    const prevImagesSources = prevImagesRef.current;

    const hasChanged =
      imagesSources.length !== prevImagesSources.length ||
      imagesSources.some((src, index) => src !== prevImagesSources[index]);

    if (!hasChanged) {
      return;
    }

    prevImagesRef.current = imagesSources;

    Promise.all(
      imagesSources.reduce((ratioPromises, currentSrc) => {
        if (!imagesAspectRatios.has(currentSrc)) {
          ratioPromises.push(getImageAspectRatio(currentSrc));
        }

        return ratioPromises;
      }, [])
    ).then((imagesRatios) => {
      imagesRatios.forEach(({ imageSrc, aspectRatio }) => {
        imagesAspectRatios.set(imageSrc, aspectRatio);
      });

      setResultRatios(imagesSources.map((src) => imagesAspectRatios.get(src)));
    });
  }, [imagesSources, imagesAspectRatios]);

  return resultRatios;
}
